import type { Ref } from 'vue';
import { computed } from 'vue';

import type { ITranslationsKeyMap } from '@modules/i18n/types';

export function getTranslationKeys(): Ref<ITranslationsKeyMap> {
  return computed(() => ({
    admin: {
      settings: {
        translate_manager: {
          title: 'TITLE',
          language: 'LANGUAGE',
          front_end: 'FRONTEND',
          back_end: 'BACKEND',
          search_locales: 'SEARCH_LOCALES',
          empty_locales: 'EMPTY_LOCALES',
          export_file_button: 'EXPORT_FILE_BUTTON',
          import_file_button: 'IMPORT_FILE_BUTTON',
          force_write: 'FORCE_WRITE',
          write_only_empty: 'WRITE_ONLY_EMPTY',
        },
      },
    },
  }));
}
